module.exports = __webpack_public_path__ + "static/media/stjerne_blue-min.1843dde3.png";